import { useT } from "../../i18n/LanguageContext";

export default function Manifesto() {
    const { t } = useT();

    return (
        <section
            id="manifesto"
            data-testid="manifesto-section"
            className="py-24 md:py-32 lg:py-40"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                <div className="lg:col-span-5 reveal">
                    <p className="overline mb-8">{t("manifesto.overline")}</p>
                    <div className="relative">
                        <picture>
                            <source srcSet="/portrait/guillermo.avif" type="image/avif" />
                            <source srcSet="/portrait/guillermo.webp" type="image/webp" />
                            <img
                                src="/portrait/guillermo.jpg"
                                alt={t("manifesto.portraitAlt")}
                                data-testid="manifesto-portrait"
                                loading="lazy"
                                decoding="async"
                                width="900"
                                height="1125"
                                className="w-full aspect-[4/5] object-cover object-center grayscale-[15%]"
                            />
                        </picture>
                        <div className="absolute -bottom-4 -right-4 hidden sm:block">
                            <picture>
                                <source srcSet="/portrait/water.avif" type="image/avif" />
                                <source srcSet="/portrait/water.webp" type="image/webp" />
                                <img
                                    src="/portrait/water.jpg"
                                    alt={t("manifesto.waterAlt")}
                                    loading="lazy"
                                    decoding="async"
                                    width="400"
                                    height="400"
                                    className="w-40 aspect-square object-cover border-8 border-[var(--sand)]"
                                />
                            </picture>
                        </div>
                    </div>
                    <p className="mt-6 text-sm text-secondary italic font-serif">
                        {t("manifesto.caption")}
                    </p>
                </div>

                <div className="lg:col-span-7 reveal">
                    <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tighter text-ink">
                        {t("manifesto.headlineA")}{" "}
                        <em className="italic font-light text-terracotta">
                            {t("manifesto.headlineEm")}
                        </em>{" "}
                        {t("manifesto.headlineB")}
                    </h2>
                    <div className="mt-10 space-y-6 text-base md:text-lg leading-relaxed text-secondary font-sans">
                        <p>
                            {t("manifesto.p1A")}
                            <span className="text-ink">{t("manifesto.p1Jam")}</span>
                            {t("manifesto.p1B")}
                        </p>
                        <p>
                            {t("manifesto.p2A")}
                            <span className="text-ink italic font-serif">
                                {t("manifesto.p2Em")}
                            </span>
                            {t("manifesto.p2B")}
                        </p>
                        <p>{t("manifesto.p3")}</p>
                        <p className="border-l-2 border-terracotta pl-5 text-ink italic">
                            {t("manifesto.p4")}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
